
export const all = (perms, requested) => { 
    return requested.every(r=> perms.includes(r))
   }
  
export const any = (perms, requested) => { 
    return requested.some(r=> perms.includes(r))
   }

export const check_permissions = (perms, requested, func) => {
    if (requested !== undefined && requested && perms){
        if (func === undefined) {
            return any(perms, requested)
        }else{
            return func(perms, requested)
        }
    }
    return true
 }

export function PermissionWrapper(props){
    if (check_permissions(props.permissions, props.access, props.func)){
        return props.children
    }
    else 
        return null
}

export function createDelayedFunction(func, delay) {
    let lastExecutionTime = 0;
  
    return function (...args) {
      const currentTime = Date.now();
  
      if (currentTime - lastExecutionTime >= delay) {
        lastExecutionTime = currentTime;
        return func(...args);
      } else {
        return args[0]
      }
    };
  }

export function snakeToTitle(str) {
  return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function parseAPIError(error) {
  if (!error.response || !error.response.data) {
    return "An error occurred."
  }

  const errors = error.response.data;

  let errorList = []

  Object.entries(errors).forEach(([key, value]) => {
    const fieldName = snakeToTitle(key);
    const errorMessage = `${fieldName} - ${value}`;
    
    if (errorMessage === "Connected Organisation - Invalid pk \"0\" - object does not exist.") {
      errorList.push("Your connected organisation cannot be determined")
    } else {
      errorList.push(errorMessage)
    }
  })

  return errorList
}


export const priceForRemainingDays = (totalAmount, planType, remainingDays) => {
  totalAmount = typeof totalAmount === 'number' ? totalAmount : parseFloat(totalAmount);
  
  var maxDays = planType === 'Yearly' ? 365 : 30;
  
  if (totalAmount <= 0) {
    return totalAmount.toFixed(2);
  }

  if (remainingDays >= maxDays) {
    return totalAmount.toFixed(2);
  }

  return parseFloat((totalAmount * remainingDays) / maxDays).toFixed(2);
}

export const getDateAfterDays = (startDate, planType = 'Yearly') => {
  let days = planType === 'Yearly' ? 364 : 29 // today + 364 = 365 days

  let futureDate = new Date(startDate)
  futureDate.setDate(futureDate.getDate() + days)

  return futureDate;
}

